import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

export const fallbackLanguage = "en-US";

let translationsReloadCount = 0;

// A reload count above zero adds a unique query param so the request bypasses
// both the service worker "translations" cache and the browser cache
const translationsLoadPath = () =>
  `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json${
    translationsReloadCount > 0 ? `?reload=${translationsReloadCount}` : ""
  }`;

export const initI18n = async (language: string, callback: () => void) => {
  await i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
      lng: language,
      fallbackLng: fallbackLanguage,
      interpolation: {
        escapeValue: false,
      },
      load: "currentOnly",
      defaultNS: "translation",
      react: {
        bindI18n: "languageChanged loaded",
      },
      backend: {
        loadPath: translationsLoadPath,
      },
    });
  callback();
};

export const reloadTranslations = async () => {
  translationsReloadCount += 1;
  const languagesToReload = Array.from(
    new Set([i18n.language, fallbackLanguage])
  );
  await i18n.reloadResources(languagesToReload);
};
